export function getLastFourChars(str: string): string {
  return str.slice(str.length - 4, str.length);
}
